import Component from '../../common/Component';
import Link from '../../common/components/Link';
import app from '../app';
import Avatar from '../../common/components/Avatar';
import listItems from '../../common/helpers/listItems';
import username from '../../common/helpers/username';
import highlight from '../../common/helpers/highlight';
import classList from '../../common/utils/classList';
export default class UserSearchResult extends Component {
  view(vnode) {
    const user = this.attrs.user;
    return m("li", {
      className: classList('UserSearchResult', this.attrs.className),
      "data-index": 'users' + user.id(),
      "data-id": user.id(),
      onclick: this.attrs.onclick
    }, this.attrs.onclick ? m("button", {
      type: "button"
    }, this.content(vnode)) : m(Link, {
      href: 'user' in app.route ? app.route.user(user) : app.forum.attribute('baseUrl') + '/u/' + user.username()
    }, this.content(vnode)));
  }
  content(vnode) {
    const user = this.attrs.user;
    const query = this.attrs.query;
    const name = username(user, name => highlight(name, query));
    return m('[', null, m(Avatar, {
      user: user
    }), m("div", {
      className: "UserSearchResult-name"
    }, name, m("div", {
      className: "badges badges--packed"
    }, listItems(user.badges().toArray()))), vnode.children);
  }
}
flarum.reg.add('core', 'common/components/UserSearchResult', UserSearchResult);